import { ProfileDataService } from './profile-data.service';
import { ObservableResult } from '../../models/result.model';
import { IAbsenceTypes, ProfileData, UserUpdateData } from '../../models/profile/profile.model';
import { IUser, ProfileStudio } from '../../models/leads/leads.model';

export class MockProfileDataService implements ProfileDataService {

  profileData = {
    User: {
      Id: 1,
      FirstName: "John",
      LastName: "Doe",
      Roles: ["Admin", "User"],
      Email: "john.doe@example.com",
      Login: "jdoe",
      Phone: "+1 555-1234",
      Mobile: "+1 555-5678",
      Available: true,
      AvatarURL: "https://static.everypixel.com/ep-pixabay/0329/8099/0858/84037/3298099085884037069-head.png",
      LanguageCode: "en",
      EnableReporting: true,
      Inactive: false,
      LastActivity: "2025-05-01T12:00:00Z",
      Organisation: "Example Corp",
      LeadMailEnabled: true,
      NotificationsEnabled: true,
      AppointmentMailEnabled: false,
      ExternalMailCCEnabled: false,
      CompletedMailEnabled: true,
      Gender: "Male"
    },
    AvatarImage: {
      Name: "3298099085884037069-head.png",
      MimeType: "image/png",
      Body: "base64EncodedImageStringHere",
      Filedate: "2025-05-01T10:00:00Z"
    },
    CurrencyCode: 'EUR',
    Roles: ["Admin", "Manager"],
    Rights: ["VIEW_DASHBOARD", "EDIT_USERS", "EXPORT_DATA"],
    AdditionalOrganisations: ["Org A", "Org B"],
    Absences: [
      {
        From: "2025-05-10",
        To: "2025-05-15",
        Enabled: true,
        AbsenceTypeId: 1,
        AbsenceTypeText: "Vacation",
        RecurringDays: 0,
        RecurringTimeFrom: "09:00",
        RecurringTimeTo: "17:00",
        Timezone: "Europe/Berlin"
      }
    ],
    Subordinates: [
      {
        Id: 2,
        FirstName: "Jane",
        LastName: "Smith",
        Email: "jane.smith@example.com",
        Login: "jsmith",
        Available: false
      }
    ],
    Tenants: [
      {
        Id: 1001,
        KKZ: "K001",
        Name: "Main Tenant",
        IsFinstral: true,
        IsPremium: true,
      }
    ]
  };

  subordinates: IUser[] = [
    {
      Id: 2,
      FirstName: "Alice",
      LastName: "Johnson",
      Email: "alice.johnson@example.com",
      Login: "ajohnson",
      Phone: "+1 555-0001",
      Mobile: "+1 555-1001",
      Available: true,
      LanguageCode: "en",
      EnableReporting: false,
      Inactive: false,
      Organisation: "Sales Dept",
      LeadMailEnabled: false,
      NotificationsEnabled: true,
      AppointmentMailEnabled: true,
      ExternalMailCCEnabled: false,
      CompletedMailEnabled: false,
      Gender: "Female"
    },
    {
      Id: 3,
      FirstName: "Bob",
      LastName: "Miller",
      Email: "bob.miller@example.com",
      Login: "bmiller",
      Phone: "+1 555-0002",
      Mobile: "+1 555-1002",
      Available: false,
      LanguageCode: "de",
      EnableReporting: true,
      Inactive: false,
      Organisation: "Support Team",
      LeadMailEnabled: true,
      NotificationsEnabled: false,
      AppointmentMailEnabled: false,
      ExternalMailCCEnabled: true,
      CompletedMailEnabled: true,
      Gender: "Male"
    }
  ];

  absenceTypes: IAbsenceTypes[] = [
    {
      Id: 1,
      Text: 'Some text',
      Inactive: false,
    },
    {
      Id: 2,
      Text: 'Some text 2',
      Inactive: true,
    }
  ];

  studios: ProfileStudio[] = [
    {
      KKZ: "S001",
      Name: "Studio Alpha",
      Address: "123 Main Street",
      PLZ: "10115",
      City: "Berlin",
      Email: "contact@studioalpha.com",
      Area: 250,
      CertificationIFT: true,
      CountryText: "Germany",
      Country: "DE",
      Mandant: {
        Id: 1001,
        KKZ: "K001",
        Name: "Main Tenant",
        IsFinstral: true,
        IsPremium: true
      }
    },
    {
      KKZ: "S002",
      Name: "Studio Beta",
      Address: "456 Side Road",
      PLZ: "8001",
      City: "Zurich",
      Email: "info@studiobeta.ch",
      Area: 180,
      CertificationIFT: false,
      CountryText: "Switzerland",
      Country: "CH",
      Mandant: {
        Id: 1002,
        KKZ: "K002",
        Name: "Secondary Tenant",
        IsFinstral: false,
        IsPremium: false
      }
    }
  ];

  getUserProfile(): ObservableResult<ProfileData> {
    return ObservableResult.ofSuccess(this.profileData);
  }

  getSubordinates(): ObservableResult<IUser[]> {
    return ObservableResult.ofSuccess(this.subordinates);
  }

  updateUserProfile(profileData: UserUpdateData): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  getAbsenceTypes(): ObservableResult<IAbsenceTypes[]> {
    return ObservableResult.ofSuccess(this.absenceTypes);
  }

  getSubstitutes(): ObservableResult<IUser[]> {
    return ObservableResult.ofSuccess(this.subordinates);
  }

  getStudios(): ObservableResult<ProfileStudio[]> {
    return ObservableResult.ofSuccess(this.studios);
  }
}
